<div class="site-container" *ngIf="!isLoadingLabels && !isLoadingSites">
	<div class="search" *ngIf="customInterface.id == undefined">
		<cpi-input-with-autocomplete
			[availableOptions]="listSitesIAC"
			[minInputLength]="0"
			[placeholder]="labels.lbl_selecione_site"
			[cleanValues]="clearValues"
			[keepValue]="false"
			[inputHeight]="'25px'"
			(onValueChange)="getSite($event)"
			*ngIf="!isLoadingSites">
		</cpi-input-with-autocomplete>

		<cpi-msp-table
			[header]="searchHeader"
			[body]="siteList"
			[height]="'60dvh'"
			[itemPadding]="'1%'"
			[insideSort]="true"
			[labels]="labels"
			(getSelectedItem)="getSite($event[0]['id'])">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="clearInputs(true)">{{ labels.lbl_gerar_novo_site }}</div>
		</div>
	</div>

	<ng-container *ngIf="customInterface.id != undefined">
		<div class="header-wrap">
			<span class="tab selected">{{ labels.lbl_geral_sites }}</span>
		</div>
		<div class="body-wrap">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_site }}</span>
				<input type="text" [value]="customInterface.site" (input)="customInterface.site = $event.target.value" />
			</div>

			<div class="button-container">
				<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
				<div class="button" (click)="clearInputs(true)">{{ labels.lbl_gerar_novo_site }}</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdating || isDisabling }"
					*ngIf="this.isButtonVisible === 1"
					(click)="deactivateSite(customInterface.id)">
					{{ labels.lbl_geral_desativar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isDisabling"></cpi-dot-bounce-loading-effect>
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdating || isDisabling }"
					*ngIf="this.isButtonVisible === 0"
					(click)="activateSite(customInterface.id)">
					{{ labels.lbl_geral_location_ativar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isDisabling"></cpi-dot-bounce-loading-effect>
				</div>
				<div class="button" [ngClass]="{ disabled: isUpdating || isDisabling }" (click)="validateForm()">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingLabels || isLoadingSites" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
